import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MY_CARDS_COLLECTIONS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const MyCardsPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_COLLECTIONS)}
      keepSearchParams
    />
  );
};

export default MyCardsPage;
